"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arrow = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Arrow = (props) => {
    return (React.createElement(Svg, { width: "20", height: "26", viewBox: "0 0 43 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", open: props.open },
        React.createElement("path", { d: "M2.05347 1.53195L21.476 22.7344L41.0059 1.6309", stroke: "#e8c893", strokeWidth: "2" })));
};
exports.Arrow = Arrow;
const Svg = styled_components_1.default.svg `
  transform: rotate(${(props) => (props.open ? '180deg' : '0deg')});
  margin: 0 30px 0 0;
  position: relative;
  top: 4px;
  float: right;
  //transition: all 0.5s ease-out;

  @media (min-width: 1140px) {
    margin: 0;
    top: 0;
  }
`;
//# sourceMappingURL=arrow.js.map